import { useEffect, useState } from "react";

export const useRenderedInputTrigger = (focusToInput) => {
  const [renderedInputTrigger, setRenderInputTrigger] = useState(0);

  const triggerRenderedInput = () => {
    setRenderInputTrigger(prev => prev + 1)
  }

  useEffect(() => {
    // rendered input represents search icon in header and search bar which comes after that
    if (renderedInputTrigger > 0) {
      focusToInput();
    }
  }, [renderedInputTrigger]);

  return triggerRenderedInput

}


// WEBPACK FOOTER //
// ./src/containers/HomePage/hooks/useRenderedInputTrigger.ts